// A instância do cliente de API que o app inteiro usa, num arquivo sem
// dependência de tela: as features importam daqui; os providers também.
// (Importar de `app/providers` criaria um ciclo: providers → router → features.)
import { obterToken } from '../auth/firebase';
import { criarCliente, type Cliente } from './cliente';

export function irParaLogin(): void {
  const proximo = encodeURIComponent(location.pathname + location.search);
  location.href = `/app/entrar?next=${proximo}`;
}

export const api: Cliente = criarCliente({ obterToken, aoPerderSessao: irParaLogin });
